/** Kart ve manşetlerde gösterilecek başlık: kısa başlık varsa o, yoksa ana başlık */
export function getNewsDisplayTitle(item: {
  title: string
  title_short?: string | null
}): string {
  return (item.title_short?.trim() || item.title).trim()
}
